import styles from "./ListActions.module.css";
import { useState } from "react";
import Dropdown from "./Dropdown";
import ItemCounter from "./ItemCounter";
import FilterButton from "./FilterButton";

export default function ListActions({
  categories,
  filter,
  count,
  count_1,
  filters,
  setFilters,
  itemCount,
}) {
  const [showOptions, setShowOptions] = useState(false);

  return (
    <main className={styles.main}>
      <div className={styles[`actions`]}>
        <ItemCounter count={count} count_1={count_1} itemCount={itemCount} />
        <FilterButton
          filter={filter}
          filters={filters}
          setFilters={setFilters}
          setShowOptions={setShowOptions}
        />
      </div>
      <Dropdown
        filters={filters}
        setFilters={setFilters}
        showOptions={showOptions}
        categories={categories}
        setShowOptions={setShowOptions}
      />
    </main>
  );
}
